import React from "react";
import { View, Text, StyleSheet, Image } from "react-native";
import { PrimaryButton, TitleText, NormalText } from "../../../common/native";
import ChooseYourAdventure from "./ChooseYourAdventure";

interface OnboardingUIProps {
  title: string;
  description: string;
  primaryActionText: string;
  onPrimaryAction: () => void;
  notificationsSlot?: React.ReactNode;
  showTourCard?: boolean;
}

const OnboardingUI: React.FC<OnboardingUIProps> = ({
  title,
  description,
  primaryActionText,
  onPrimaryAction,
  notificationsSlot,
  showTourCard = true,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <TitleText text={title} style={styles.title} numberOfLines={2} />
        {notificationsSlot}

        {/* <Image
          source={{
            uri: "https://pub-0991182fdab143cf938953a8d6ab8813.r2.dev/photo-assets/surgeon%20resting.webp",
          }}
          style={styles.subImage}
        /> */}

        {showTourCard && (
          <View style={styles.tourCard}>
            <NormalText
              text="🎉 First time here? Take a quick tour to get started."
              style={styles.tourText}
              numberOfLines={3}
            />
            <PrimaryButton
              text={primaryActionText}
              roundBorderRadius
              onPress={onPrimaryAction}
            />
          </View>
        )}
        <ChooseYourAdventure />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 8, // reduced from 24
    paddingHorizontal: 0,
    paddingBottom: 24,
    backgroundColor: "#FFFFFF",
    alignItems: "center",
    justifyContent: "center",
  },
  innerContainer: {
    width: "100%",
    // maxWidth: 1500,
    gap: 24,
    alignItems: "center",
  },
  title: {
    fontSize: 30,
    fontWeight: "700",
    textAlign: "center",
    color: "#111",
  },
  subTitle: {
    fontSize: 18,
    fontWeight: "400",
    textAlign: "center",
    color: "#555",
    marginTop: 8,
  },
  buttonContainer: {
    flexDirection: "column",
    width: 200,
    gap: 16,
    marginTop: 24,
  },
  trialCountdown: {
    marginTop: 16,
  },
  trialCountdownText: {
    fontSize: 14,
    textAlign: "center",
    color: "#777",
  },
  subImage: {
    width: "100%",
    aspectRatio: 2.5,
    borderRadius: 8,
    marginBottom: 12,
    resizeMode: "cover",
  },
  tourCard: {
    backgroundColor: "#F1FAFF",
    borderRadius: 16,
    padding: 24,
    width: "100%",
    maxWidth: 480,
    alignItems: "center",
    shadowColor: "#000",
    shadowOpacity: 0.04,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 8,
    elevation: 3,
    marginTop: 12,
    gap: 16,
  },
  tourText: {
    fontSize: 16,
    fontFamily: "Urbanist500",
    color: "#333",
    textAlign: "center",
  },
});

export default OnboardingUI;
